<template>
     <card class="tw-text-center">
        <div class="tw-py-2">
            <stepper
				:steps="stages"
				:current-step="currentStep"></stepper>
        </div>
    </card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import Stepper from '@/modules/shared/components/ui/stepper/Stepper';
import { applySpec, map, pathOr, pipe, prop } from 'ramda';
import { mapState } from 'vuex';

function created() {
	// const stage = this.$store.state.jobProfile &&
	// 	this.$store.state.jobProfile.mainData &&
	// 	this.$store.state.jobProfile.mainData.config &&
	// 	this.$store.state.jobProfile.mainData.config.stages
	//  this.$store.state.jobProfile.mainData.config.stages : [];
	// const current = this.currentStep;
	// if (this.currentStep === current) {
	// 	const index = this.currentStep - 1;
	// 	const objectStep = stage[index];
	// 	this.$emit('code-step', objectStep);
	// }
}

function data() {
	return {
	};
}

function stepClass() {
	return step => ({
		completed: this.stages.indexOf(step) < this.currentStep - 1,
	});
}

export default {
	name: 'model-stepper',
	components: {
		Card,
		Stepper,
	},
	beforeCreate() {
		this.$store.dispatch('recruitment/loadRecruitmentConfig');
	},
	created,
	beforeMount() {
		const stage = this.$store.state.jobProfile &&
			this.$store.state.jobProfile.mainData &&
			this.$store.state.jobProfile.mainData.config &&
			this.$store.state.jobProfile.mainData.config.stages
			? this.$store.state.jobProfile.mainData.config.stages : [];
		const current = this.currentStep;
		if (this.currentStep === current) {
			const index = this.currentStep - 1;
			const objectStep = stage[index];
			this.$emit('code-step', objectStep);
		}
	},
	mounted() {
	},
	data,
	methods: {
	},
	computed: {
		stepClass,
		...mapState('recruitment', {
			stages: pipe(
				pathOr([], ['mainData', 'config', 'stages']),
				map(
					applySpec({
						code: prop('code'),
						label: prop('title'),
					}),
				),
			),
			stage: pathOr([], ['mainData', 'config', 'stages']),
		}),
	},
	watch: {
		stage: {
			handler(newValue) {
				const current = this.currentStep;
				if (this.currentStep === current) {
					const index = this.currentStep - 1;
					const objectStep = newValue[index];
					this.$emit('code-step', objectStep);
				}
			},
		},
	},
	props: ['currentStep'],
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/content/model-stepper.vue